import React, { ReactText } from "react"
import { useSnackbar, SnackbarMessage, OptionsObject } from "notistack"
import Slide, { SlideProps } from "@material-ui/core/Slide"

export type MessageType = {
  default: (msg: SnackbarMessage, option?: OptionsObject) => () => void
  warning: (msg: SnackbarMessage, option?: OptionsObject) => () => void
  success: (msg: SnackbarMessage, option?: OptionsObject) => () => void
  error: (msg: SnackbarMessage, option?: OptionsObject) => () => void
  info: (msg: SnackbarMessage, option?: OptionsObject) => () => void
  closeSnackbar: (key?: ReactText) => void
}

function TransitionDown(props: JSX.IntrinsicAttributes & SlideProps) {
  return <Slide {...props} direction="down" />
}

export default function useMessage(): MessageType {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const methods = {
    default: (
      msg: SnackbarMessage,
      option?: OptionsObject,
      duration?: number
    ) => {
      // closeSnackbar()
      const key = enqueueSnackbar(msg, {
        TransitionComponent: TransitionDown,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        autoHideDuration: duration || 2000,
        ...option,
      })
      return () => {
        try {
          closeSnackbar(key)
        } catch (error) { }
      }
    },
    warning: (
      msg: SnackbarMessage,
      option?: OptionsObject,
      duration?: number
    ) => {
      return methods.default(
        msg,
        {
          variant: "warning",
          ...option,
        },
        duration
      )
    },
    success: (
      msg: SnackbarMessage,
      option?: OptionsObject,
      duration?: number
    ) => {
      return methods.default(
        msg,
        {
          variant: "success",
          ...option,
        },
        duration
      )
    },
    error: (
      msg: SnackbarMessage,
      option?: OptionsObject,
      duration?: number
    ) => {
      return methods.default(
        msg,
        {
          variant: "error",
          ...option,
        },
        duration
      )
    },
    info: (msg: SnackbarMessage, option?: OptionsObject, duration?: number) => {
      return methods.default(
        msg,
        {
          variant: "info",
          ...option,
        },
        duration
      )
    },
    closeSnackbar,
  }
  return methods
}
